export default __webpack_public_path__ + "static/media/info.235c41fb.svg";